import CardInformation from './CardInformation';

export default CardInformation;
